import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { apiJson } from "../lib/api_errore"
import { conservaDalMorph } from "../lib/conserva_morph"

// La guida di benvenuto (GuidaBenvenuto.js, 31a5bd1): si apre da sola se la persona non ha scelto «Non mostrare più»
// (guida_vista dalle preferenze, letta dal layout) e si riapre da «Percorso in breve» dell'assistente (evento
// "guida-benvenuto:apri"). Chiusa senza «Non mostrare più» non torna fino al prossimo caricamento della pagina: il segno
// è a livello di modulo, come nell'originale, e sopravvive alle visite Turbo.
let chiusaInQuestaVisita = false

export default class extends Controller {
  static targets = ["schermata", "corrente"]
  static values = { vista: Boolean }

  connect() {
    this.i = 0
    this.mostra()
    this.apri = this.apri.bind(this)
    window.addEventListener("guida-benvenuto:apri", this.apri)
    // il dialog interno si collega dopo questo controller: l'apertura automatica al giro successivo
    if (!this.vistaValue && !chiusaInQuestaVisita) this.timer = setTimeout(this.apri, 0)
  }

  disconnect() {
    clearTimeout(this.timer)
    window.removeEventListener("guida-benvenuto:apri", this.apri)
  }

  conserva(event) {
    conservaDalMorph(this.element, event)
  }

  apri() {
    this.i = 0
    this.mostra()
    window.dispatchEvent(new CustomEvent("dialog:open", { detail: { id: "guida-benvenuto" } }))
  }

  avanti() {
    if (this.i < this.schermataTargets.length - 1) this.i += 1
    this.mostra()
  }

  indietro() {
    if (this.i > 0) this.i -= 1
    this.mostra()
  }

  // Solo la schermata corrente nel DOM: una copia del suo <template>.
  mostra() {
    this.correnteTarget.replaceChildren(this.schermataTargets[this.i].content.cloneNode(true))
  }

  // Ogni chiusura (Fine, X, sfondo, Esc, un pulsante della schermata) passa da qui con l'evento dialog:closed.
  chiusa() {
    chiusaInQuestaVisita = true
  }

  chiudi() {
    chiusaInQuestaVisita = true
    window.dispatchEvent(new CustomEvent("dialog:close", { detail: { id: "guida-benvenuto" } }))
  }

  nonMostrare() {
    apiJson("/api/me/preferenze", { method: "PUT", body: { guida_vista: true } }).catch(() => {})
    this.chiudi()
  }

  vai(event) {
    this.chiudi()
    Turbo.visit(event.params.to)
  }
}
